<template>
  <div class="current-level text-center">
    <v-img
      :width="iconSize"
      class="tier-icon mx-auto grey400 mb-2"
      :aspect-ratio="1" contain
      :src="require(`@/assets/img/levels/tiers/${tier}-large.png`)"
    />
    <h4
      class="level green300--text text-body-1 font-weight-semibold"
      v-text="$tc('common.level', level)"
    />
    <h5 class="xp green200--text text-caption font-weight-semibold">
      {{ xp | toLocaleInt }} XP
    </h5>
  </div>
</template>

<script>
export default {
  props: {
    iconSize: {
      type: Number,
      default: 64,
    },
    xp: {
      type: Number,
      default: 0,
    },
    level: {
      type: Number,
      default: 0,
    },
    tier: {
      type: Number,
      default: 0,
    },
  },
}
</script>
